import { axiosBackendInstance, axiosDefaultInstance } from "@config/axios";
import { AxiosRequestConfig, Method } from "axios";

type RequestResponse = Record<string, unknown>;
type RequestBody = Record<string, unknown>;

export const backendRequest = async <D = RequestResponse, B = RequestBody>(
  url: string,
  method: Method = "GET",
  body?: B,
  parameters: Record<string, unknown> = {}
): Promise<D> => {
  const config: AxiosRequestConfig = {
    url,
    method,
    data: body,
    params: parameters,
  };

  const response = await axiosBackendInstance(url, config);
  return response.data;
};

export const backendBlobRequest = async (
  url: string,
  method: Method = "POST",
  body: Record<string, unknown> = {},
  parameters: Record<string, unknown> = {}
): Promise<Blob> => {
  const config: AxiosRequestConfig = {
    url,
    method,
    data: body,
    params: parameters,
    responseType: "blob",
  };

  const response = await axiosBackendInstance(url, config);
  return response.data;
};

export const blobRequest = async (url: string): Promise<Blob> => {
  const response = await axiosDefaultInstance(url, {
    method: "POST",
    responseType: "blob",
  });

  return response.data;
};

export const defaultRequest = async (url: string): Promise<{ downloadUrl: string }> => {
  const response = await axiosDefaultInstance(url, {
    method: "GET",
  });

  return response.data;
};
